export const VIEW_PREFERENCES_STORAGE_KEY = 'operations-view-preferences'

export const VIEW_PREFERENCE_OPTIONS = Object.freeze({
  interfaceScale: Object.freeze([
    { value: 'default', label: 'Default · 100%' },
    { value: 'large', label: 'Large · 112.5%' },
    { value: 'extra-large', label: 'Extra large · 125%' },
  ]),
  density: Object.freeze([
    { value: 'comfortable', label: 'Comfortable' },
    { value: 'standard', label: 'Standard' },
    { value: 'compact', label: 'Compact' },
  ]),
  contentWidth: Object.freeze([
    { value: 'contained', label: 'Contained' },
    { value: 'wide', label: 'Wide' },
    { value: 'full', label: 'Full' },
  ]),
  tableMode: Object.freeze([
    { value: 'auto', label: 'Automatic' },
    { value: 'table', label: 'Tables' },
    { value: 'cards', label: 'Cards' },
  ]),
})

export const DEFAULT_VIEW_PREFERENCES = Object.freeze({
  interfaceScale: 'default',
  density: 'standard',
  contentWidth: 'contained',
  tableMode: 'auto',
})

function isAllowedPreference(key, value) {
  return VIEW_PREFERENCE_OPTIONS[key]?.some((option) => option.value === value) === true
}

export function normalizeViewPreferences(candidate) {
  return Object.fromEntries(
    Object.entries(DEFAULT_VIEW_PREFERENCES).map(([key, defaultValue]) => [
      key,
      isAllowedPreference(key, candidate?.[key]) ? candidate[key] : defaultValue,
    ]),
  )
}

export function readViewPreferences(storage = localStorage) {
  const stored = storage.getItem(VIEW_PREFERENCES_STORAGE_KEY)
  if (!stored) return { ...DEFAULT_VIEW_PREFERENCES }

  try {
    return normalizeViewPreferences(JSON.parse(stored))
  } catch (error) {
    console.warn('Ignoring invalid Operations display preferences:', error)
    return { ...DEFAULT_VIEW_PREFERENCES }
  }
}

export function writeViewPreferences(preferences, storage = localStorage) {
  storage.setItem(VIEW_PREFERENCES_STORAGE_KEY, JSON.stringify(normalizeViewPreferences(preferences)))
}

export function applyViewPreferenceAttributes(preferences, root = document.documentElement) {
  const normalized = normalizeViewPreferences(preferences)
  root.setAttribute('data-interface-scale', normalized.interfaceScale)
  root.setAttribute('data-density', normalized.density)
  root.setAttribute('data-content-width', normalized.contentWidth)
}
